/* eslint-disable */
(function () {
  function resetJfbForm() {
    var form = document.querySelector('form.jet-form-builder');
    if (!form) return;

    form.reset();

    // Desmarcar checkboxes y radios
    var checks = form.querySelectorAll('input[type="checkbox"], input[type="radio"]');
    Array.prototype.forEach.call(checks, function (el) {
      el.checked = false;

      if (el.hasAttribute('checked')) el.removeAttribute('checked');

      try {
        el.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {
        var evt = document.createEvent('Event');
        evt.initEvent('change', true, true);
        el.dispatchEvent(evt);
      }
    });

    // Limpieza explícita de elegir_vehiculo
    var vehiculoOptions = form.querySelectorAll('[name="elegir_vehiculo"]');
    Array.prototype.forEach.call(vehiculoOptions, function (el) {
      el.checked = false;
      if (el.hasAttribute('checked')) el.removeAttribute('checked');

      try {
        el.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {
        var evt = document.createEvent('Event');
        evt.initEvent('change', true, true);
        el.dispatchEvent(evt);
      }
    });

    var selectsToClear = [
      'marca_coche',
      'tcombustible_coche',
      'modelo_coche',
      'marca_moto',
      'modelo_moto',
      'cilindrada_moto',
      'ccaa_comprador'
    ];

    selectsToClear.forEach(function (name) {
      var el = form.querySelector('[name="' + name + '"]');
      if (!el) return;

      if (el.tagName && el.tagName.toLowerCase() === 'select') {
        el.selectedIndex = 0;
      } else {
        el.value = '';
      }

      try {
        el.dispatchEvent(new Event('change', { bubbles: true }));
        el.dispatchEvent(new Event('input', { bubbles: true }));
      } catch (e) {}
    });

    var hiddenToClear = [
      'hidden_marca_coche',
      'hidden_modelo_coche',
      'hidden_combustible',
      'hidden_cilindrada',
      'hidden_cilindros',
      'hidden_potencia_kw',
      'hidden_potencia_cv',
      'hidden_potencia_fiscal',
      'hidden_impvehic',
      'hidden_antiguedad',
      'hidden_devaluacion',
      'hidden_cociente_devaluacion',
      'hidden_base_imponible',
      'hidden_ccaa_comprador',
      'hidden_tipo_impositivo',
      'hidden_cuota_itp',
      'hidden_itp'
    ];

    hiddenToClear.forEach(function (name) {
      var el = form.querySelector('[name="' + name + '"]');
      if (!el) return;
      el.value = '';
      try {
        el.dispatchEvent(new Event('input', { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {}
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    resetJfbForm();
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      resetJfbForm();
    }
  });
})();


// WEBPACK FOOTER //
// ./scripts/formularios-itp/form-reset.js